export default __webpack_public_path__ + "static/pure_banner-b2b33d73ab3640bd9877458b98a35c92.gif";